export function getStopPropagation(actionHandlers) {
	const stopPropagation = {};
	for (const k in actionHandlers) {
		if (actionHandlers[k].some(v => v.stopPropagation)) stopPropagation[k] = true;
	}

	return stopPropagation;
}
